<template>
  <v-container class="">
    <banner></banner>
    <template>
      <div  class="text-center">
        <v-dialog v-model="dialog" width="500">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
              Click Me
            </v-btn>
          </template> -->

          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Your Submission is Saved
            </v-card-title>

            <v-card-text class="font-weight-bold mt-2"
              >Thank you for your information. And thank you for making our city
              better and safer. You may choose below to print a copy of this
              information for your records.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="print"> Print </v-btn>
              <v-btn color="primary" text @click="close"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- Instructions -->
    <v-container class="instructions">
      <v-row class="instruct-text ma-0">
        <v-col cols="12" class="d-flex flex-column align-center">
          <img src="../images/gold-badge-320.png" />
          <h6>Reno Police Department</h6>
          <p class="mb-0">911 Kuenzli Street</p>
          <p class="mb-0">Reno, NV 89502</p>
          <p class="mb-3">775-334-2175</p>
          <ul>
            <li>
              This Letter of Authority is pursuant to R.M.C. 8.10.012 and
              acknowledges that the Reno Police Department will enforce no
              loitering at the property listed by the owner or owner’s agent.
            </li>
            <li>
              The Letter of Authority form must be completed and contain the
              property owner's name, address, and telephone number. At a
              minimum, the property owner must provide at least one alternate
              contact person who is aware the Reno Police Department may contact
              him or her and agrees with the conditions outlined in the letter
              of authority.
            </li>
            <li>
              The property owner or property owner's agent must purchase “No
              Loitering” sign(s) at the Reno Police Department and post them on
              the property.
            </li>
            <li>
              This request for assistance and loitering enforcement form letter
              does not create a special relationship between the party
              responsible or any other person and the City of Reno or the Reno
              Police Department or any of its agents, officers, employees, or
              volunteers.
            </li>
            <li>
              By activating the Letter of Authority below, I acknowledge
              participation in the Loitering program.
            </li>
          </ul>
        </v-col>
      </v-row>

      <!-- FORM -->
      <v-container
        class="form mb-16 d-flex flex-column justify-center align-center"
      >
        <v-form
          id="full_form"
          ref="formIn"
          class="d-flex flex-column justify-center"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12" class="py-0">
              <v-checkbox
                id="confirm_city"
                v-model="formIn.confirm_city"
                label="I confirm this property is within the city limits of Reno, NV"
                required
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.today_date"
                label="Today's Date"
                type="text"
                outlined
                aria-readonly="true"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                readonly
                aria-readonly="true"
                v-model="formIn.today_time"
                label="Current Time"
                type="text"
                outlined
                maxlength=""
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                :rules="reqRules"
                v-model="formIn.owner_name"
                label="Property Owner's Name"
                type="text"
                maxlength="120"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                :rules="reqRules"
                v-model="formIn.contact_phone"
                label="Contact Telephone Number"
                hint="Best telephone number to contact you"
                persistant-hint
                v-mask="'(###) ###-####'"
                maxlength="14"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.contact_email"
                label="Email Address"
                maxlength="120"
                required
                :rules="emailRules"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" class="pb-4">
              <v-select
                class=""
                id="existing_letter"
                v-model="formIn.existing_letter"
                :items="existing_letters"
                label="Is this request a renewal of an existing Letter of Authority or for a new Letter of Authority?"
                attach
              ></v-select>
            </v-col> -->
            <v-col cols="12" class="py-0 mt-2">
              <v-text-field
                v-model="formIn.effective_date"
                label="Effective Date of the Letter of Authority"
                type="date"
                outlined
                :rules="reqRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                class=""
                id="property_type"
                v-model="formIn.property_type"
                :items="property_types"
                label="Property Type"
                attach
                required
              ></v-select>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.property_name"
                label="Commercial Property Name"
                hint="Examples - National Automobile Museum, Trader Joes, etc"
                persistant-hint
                maxlength="120"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <span>Property Address</span>
              <v-text-field
                v-model="formIn.address_line1"
                label="Adress Line 1"
                maxlength="60"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.address_line2"
                label="Adress Line 2"
                hint="Suite #, Apt#"
                persistant-hint
                maxlength="60"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.city"
                label="City"
                maxlength="60"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-select
                class=""
                id="existing_letter"
                v-model="formIn.state"
                :items="States"
                label="State"
                attach
              ></v-select>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.zip"
                label="Zip"
                maxlength="9"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.alt_contact_name1"
                label="Alternate Contact Name - #1"
                maxlength="120"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.alt_contact_phone1"
                label="Alternate Contact Telephone - #1"
                v-mask="'(###) ###-####'"
                maxlength="14"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.alt_contact_name2"
                label="Alternate Contact Name - #2"
                maxlength="120"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.alt_contact_phone2"
                label="Alternate Contact Telephone - #2"
                v-mask="'(###) ###-####'"
                maxlength="14"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pb-16">
            <div>
              <h5>Authorizing Affirmation</h5>
              <span
                >I am the owner, or owner's agent, in lawful possession of
                certain real property located within the city limits of Reno,
                NV.</span
              ><br />
              <span
                >I am concerned about possible fire, theft, vandalism, drug
                dealing, and/or drug usage caused by trespassers on the
                property. The above-listed premise or property is closed to the
                public. I have posted the premises or property as being closed
                to the public. I hereby request that the Reno Police Department
                enforce the loitering provisions of Reno Municipal Code 8.10.012
                concerning the above-listed property. I expressly authorize your
                officers to arrest and/or issue citations for loitering
                violations starting on the above effective date.</span
              >
            </div>

            <v-col cols="12" class="py-0">
              <v-checkbox
                id="auth_agree"
                v-model="formIn.auth_agree"
                label="By Checking this box, I am agreeing to the above Affirmation"
                required
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.auth_email"
                label="Re-enter Email Address"
                maxlength="120"
                required
                :rules="emailRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="formIn.owner_dl"
                label="State Issue ID/DL #"
                maxlength="12"
                required
              ></v-text-field>
            </v-col>

            <div>
              <h5>Activate the Letter of Authority</h5>
              <ul>
                <li>
                  Note: By re-entering your email above, and clicking the submit
                  button below, you are acknowledging and agreeing to all of the
                  terms and conditions contained in this form.
                </li>
                <li>
                  I understand it is my responsibility to secure the needed
                  signs and it is my responsibility to ensure those signs are
                  posted at the above property.
                </li>
                <li>
                  This enforcement authorization is revocable by written
                  documentation delivered to the Reno Police Department 911
                  Kuenzli Street Reno, NV 89502.
                </li>
                <li>
                  If you cannot complete this letter of authority online, then
                  please complete it at the front desk window at the above
                  address. Front desk hours are Monday through Saturday from
                  8:00AM to 5:30PM.
                </li>
              </ul>
            </div>
            <!-- <v-col cols="12" class="mt-3 py-0">
              <v-select
                class=""
                id="activate_letter"
                v-model="formIn.activate_letter"
                :items="activate_letters"
                label="Activate the Letter of Authority?"
                attach
              ></v-select>
            </v-col> -->
            <v-col cols="12" class="mt-3 py-0">
              <v-btn
                style="background-color: #0b3c5d"
                class="bluebtn white--text"
                @click="submit"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .instructions {
    margin-top: 50px;
  }
  .instructions,
  .form {
    max-width: 768px;
    width: 100%;
  }
  .instructions .row {
    max-width: 768px !important;
  }

  .instruct-text img {
    width: 20%;
  }

  #full_form {
    width: 90%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 1440 media q */
@media (min-width: 1440px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
export default {
  name: "home",
  components: {
    banner,
  },
  mixins: [bus_common],

  data: () => ({
    valid: true,
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    reqRules: [(v) => !!v || "Field is required"],
    dialog: false,

    dialogDelete: false,
    id: 22,
    formIn: {
      confirm_city: false,
      today_date: "",
      today_time: "",
      owner_name: "",
      contact_phone: "",
      contact_email: "",
      effective_date: "",
      existing_letter: "",
      property_name: "",
      property_type: "",
      address_line1: ".",
      address_line2: "",
      city: "Reno",
      state: "NV",
      zip: "",
      alt_contact_name1: "",
      alt_contact_phone1: "",
      alt_contact_name2: "",
      alt_contact_phone2: "",
      auth_email: "",
      auth_agree: false,
      owner_dl: "",
      activate_letter: "",
    },
    formIn_dev: {
      confirm_city: true,
      today_date: "",
      today_time: "",
      owner_name: "John Jacob Jinglehimmersmitt",
      contact_phone: "(775) 123-1234",
      contact_email: "jvonmolt@gmail.com",
      effective_date: "2025-01-01",
      existing_letter: "New Authorization Letter",
      property_name: "Bibi's Fish Cafe",
      property_type: "Commercial",
      address_line1: "123 Here St.",
      address_line2: "Suite 9",
      city: "Reno",
      state: "NV",
      zip: "89502",
      alt_contact_name1: "alt_contact_name1",
      alt_contact_phone1: "(775) 123-1235",
      alt_contact_name2: "alt_contact_name2",
      alt_contact_phone2: "(775) 123-1236",
      auth_email: "jvonmolt@gmail.com",
      auth_agree: false,
      owner_dl: "123456789012",
      activate_letter: "NO",
    },
    formIn_new: {
      dialog: false,
      confirm_city: true,
      today_date: "",
      today_time: "",
      owner_name: "",
      contact_phone: "",
      contact_email: "",
      effective_date: "",
      existing_letter: "",
      property_name: "",
      property_type: "",
      address_line1: "",
      Address_line2: "",
      city: "Reno",
      state: "NV",
      zip: "",
      alt_contact_name1: "",
      alt_contact_phone1: "",
      alt_contact_name2: "",
      alt_contact_phone2: "",
      auth_email: "",
      auth_agree: false,
      owner_dl: "",
      activate_letter: "No",
    },
    States: [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ],

    existing_letters: [
      "Renewal of an existing letter",
      "New Authorization Letter",
    ],

    property_types: [
      "Residential",
      "Commercial",
      "Empty Lot",
      "Railroad Easement",
    ],

    activate_letters: ["YES", "NO"],
  }),

  computed: {},

  watch: {
    // dialog(val) {
    //   val || this.close();
    // },
    // dialogDelete(val) {
    //   val || this.closeDelete();
    // },
  },

  methods: {
    print() {
      let self = this;
      this.$refs.formIn.reset();
      this.dialog = false;
      window.open("/print?id=" + this.id);
      setTimeout(() => {
        self.datemeup();
      }, 500);
    },
    submit() {
      if (this.$refs.formIn.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Some items area not correct. Please look at the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.formIn.auth_email != this.formIn.contact_email) {
        this.swall_it(
          "Submit Status",
          "Emails much match.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.formIn.confirm_city == false) {
        this.swall_it(
          "Submit Status",
          "Please confim city at the top of the form.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      this.mrbreakpoint("subby");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.letter = this.mno(this.formIn);
      if (formIn.letter.auth_agree != true) {
        this.swall_it(
          "Submit Status",
          "You must use the checkbox and agree to section on authorizing affirmation to submit your letter.",
          "warning",
          null,
          null
        );
        return true;
      }
      formIn.letter.today_time = this.parseTimeStringToDate(
        formIn.letter.today_time
      );
      formIn.letter.today_date = this.format_date_sql(formIn.letter.today_date);
      formIn.letter.effective_date = this.format_date_sql(
        formIn.letter.effective_date
      );

      formIn.apiname = "submit";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.id = data.letterId;
          this.show_loader(false);
          self.dialog = true;
          // this.swall_it("Submit Status", "Success!", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error submit letter data", msg, "error", null, null);
        });
    },

    editItem(item) {
      this.editedIndex = this.logs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.logs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.logs.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$refs.formIn.reset();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.datemeup();
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    message1() {
      alert("This button does nothing yet.");
    },
    datemeup() {
      this.formIn.today_date = this.format_date_us(new Date());
      this.formIn.today_time = this.formatTime(new Date());
    },
    init() {
      console.log("init init");
      this.formIn_new.today_date = this.format_date_us(new Date());
      this.formIn_new.today_time = this.formatTime(new Date());
      this.formIn_dev.today_date = this.format_date_us(new Date());
      this.formIn_dev.today_time = this.formatTime(new Date());
      this.formIn = this.mno(this.formIn_new);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
